import './travel-gallery.scss';
import GLightbox from 'glightbox';
export default () => {
	GLightbox( {
		loop: true,
	} );
};
